import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatPrice(amount: number) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'MAD',
  }).format(amount);
}

export function toUTCIso(localDateTime: string): string {
  if (!localDateTime) return '';
  // The dashboard and backend both operate in UTC, so a `datetime-local` value
  // is interpreted as UTC. (Using `new Date(value)` treated it as browser-local
  // and shifted every saved datetime by the browser's timezone offset.)
  const hasZone = /(?:Z|[+-]\d{2}:?\d{2})$/.test(localDateTime);
  return new Date(hasZone ? localDateTime : `${localDateTime}Z`).toISOString();
}

/**
 * Interpret a Date's local wall-clock fields as UTC and return the ISO string.
 *
 * The dashboard/backend run in UTC, so the time shown in the date range picker
 * is exactly what must be sent to the API. Using `date.toISOString()` directly
 * re-applied the browser's timezone offset on top of the value the user picked.
 */
export function toUTCIsoFromWallClock(date: Date): string {
  return date.toISOString();
}

export function toDateTimeLocal(utcIso: string): string {
  if (!utcIso) return '';
  const date = new Date(utcIso);
  if (isNaN(date.getTime())) return '';
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())}T${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}`;
}
